import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import React from 'react'

interface LogoWithTextProps {
	size: number
}

const aspectRatio = 1500 / 476

const LogoWithText: React.FC<LogoWithTextProps> = ({ size }) => {
	const theme = useTheme()
	const isXs = useMediaQuery(theme.breakpoints.only('xs'))
	const isSm = useMediaQuery(theme.breakpoints.only('sm'))
	const isMd = useMediaQuery(theme.breakpoints.only('md'))
	const isLg = useMediaQuery(theme.breakpoints.only('lg'))

	const sizeMultiplier = isXs ? 0.8 : isSm ? 0.9 : isMd ? 1.0 : isLg ? 1.1 : 1.2
	const finalHeight = size * sizeMultiplier
	const finalWidth = finalHeight * aspectRatio

	return (
		<>
			<img
				src='assets/logos-with-text/logo-with-text-light.png'
				alt='logo'
				className='hidden dark:block'
				style={{ width: finalWidth, height: finalHeight }}
			/>
			<img
				src='assets/logos-with-text/logo-with-text-dark.png'
				alt='logo'
				className='block dark:hidden'
				style={{ width: finalWidth, height: finalHeight }}
			/>
		</>
	)
}

export default LogoWithText
